import React from 'react'
import { GLBModel } from '../../GLBModel'
import type { DecorationsProps } from '../types'

export const Decorations: React.FC<DecorationsProps> = ({ height, onBackgroundClick }) => (
  <>
    <GLBModel
      modelUrl="/cdn/3d/room7-optimized.glb"
      modelPosition={[450, -15, 340]}
      modelScale={[120, 120, 120]}
      modelRotation={[0, Math.PI / 2, 0]}
      shouldCastShadow
      shouldReceiveShadow
      onClick={onBackgroundClick}
      userData={{ isRoom: true }}
    />
    <GLBModel
      modelUrl="/cdn/assets/3d-models/waze-with-flowers.glb"
      useDraco
      modelPosition={[-15, height, 33]}
      modelScale={[0.9, 0.9, 0.9]}
      shouldCastShadow
      shouldReceiveShadow
      onClick={onBackgroundClick}
      userData={{ isWazeWithFlowers: true }}
    />
  </>
)
